module.exports = __webpack_public_path__ + "static/media/cr.93beca1d.svg";